import { imappend } from '@/redux/im/action';
import store from '@/redux/index';

const { dispatch, getState } = store;
export const outline = (type = 1, html?: string): boolean => {
    const isOutline = !window.navigator.onLine;
    if (isOutline) {
        if (type === 1) {
            IM.IMServer.notice('warn', '网络开小差了，请检查网络连接是否正常');
        }
        if (type === 2) {
            IM.Toast.error({ content: '网络开小差了' });
        }
        if (type === 3) {
            imappend({ message: html, type: 'offline', ctx: { key: `${dayjs().valueOf()}` } })(
                dispatch,
                getState
            );
        }
    }
    return isOutline;
};
